module.exports = __webpack_public_path__ + "media/img/help_center/Student_Message_05-3ee26cb926d4c1abb6e143c49b2b7075.jpg";